import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import FreeSection from './components/FreeSection';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import DataSecurity from './components/DataSecurity';
import Footer from './components/Footer';
import { useEffect } from 'react';
import useScrollSpy from './useScrollSpy';

function App() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 50);
    }
  }, []);
  useScrollSpy([
    'home',
    'funcionalidades',
    'como-funciona',
    'gratuito',
    'depoimentos',
    'faq',
    'privacidade',
    'termos-uso',
    'seguranca',
  ]);
  return (
    <div className='App'>
      <Header />
      <Hero />
      <Features />
      <HowItWorks />
      <FreeSection />
      <Testimonials />
      <FAQ />
      <PrivacyPolicy />
      <TermsOfService />
      <DataSecurity />
      <Footer />
    </div>
  );
}

export default App;
